import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import AuthGuard from '@/components/auth-guard';
import { EntitySettingsView } from '@/components/entity-settings/entity-settings-view';

export const Route = createFileRoute('/organizations/settings')({
  component: OrganizationSettingsPage,
});

function OrganizationSettingsPage() {
  return (
    <AuthGuard>
      <Suspense fallback={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
          <CircularProgress size={32} />
        </Box>
      }>
        <EntitySettingsView
          type="organizations"
          title="Organization Profile Settings"
          breadcrumbLabel="Organizations"
          breadcrumbLink="/organizations"
        />
      </Suspense>
    </AuthGuard>
  );
}
